import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { OverviewDashboardComponent } from './components/overview-dashboard/overview-dashboard.component';
import { FacilitiesOverviewComponent } from './components/facilities-overview/facilities-overview.component';
import { LastEquipmentEventsComponent } from './components/last-equipment-events/last-equipment-events.component';
import { PageToolbarComponent } from '../../shared/components/page-toolbar/page-toolbar.component';

@Component({
  standalone: true,
  selector: 'mon-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    OverviewDashboardComponent,
    FacilitiesOverviewComponent,
    LastEquipmentEventsComponent,
    PageToolbarComponent,
  ],
})
export class DashboardComponent {}
